import type { InputHTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/cn";

interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "role"> {
	label: ReactNode;
	hint?: ReactNode;
}

export const Switch = ({ label, hint, className, ...props }: SwitchProps) => (
	<label className="flex cursor-pointer items-start gap-3">
		<span className="relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center">
			<input
				type="checkbox"
				role="switch"
				className={cn("peer absolute inset-0 z-10 m-0 cursor-pointer opacity-0", className)}
				{...props}
			/>
			<span
				aria-hidden="true"
				className={cn(
					"h-5 w-9 rounded-full border border-line-strong bg-raised transition-colors",
					"peer-checked:border-ink peer-checked:bg-ink",
					"peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-ink",
					"peer-disabled:opacity-40",
				)}
			/>
			<span
				aria-hidden="true"
				className={cn(
					"pointer-events-none absolute top-1/2 left-0.5 h-3.5 w-3.5 -translate-y-1/2 rounded-full",
					"bg-surface shadow-sm transition-transform peer-checked:translate-x-4",
					"peer-disabled:opacity-40",
				)}
			/>
		</span>
		<span className="space-y-0.5">
			<span className="block text-sm text-ink">{label}</span>
			{hint ? <span className="block text-xs text-ink-muted">{hint}</span> : null}
		</span>
	</label>
);
